import React, { useEffect, useRef } from 'react';

interface PublisherAudioPlayerProps {
    stream: MediaStream;
    username: string;
    displayName?: string;
    isLocal?: boolean;
}

export const PublisherAudioPlayer: React.FC<PublisherAudioPlayerProps> = ({
    stream,
    username,
    displayName,
    isLocal = false,
}) => {
    const audioRef = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        if (audioRef.current && stream) {
            try {
                audioRef.current.srcObject = stream;

                audioRef.current.play().catch((err) => {
                    console.error(`Error playing audio for ${username}:`, err);
                });
            } catch (e) {
                console.error(`Error setting audio source for ${username}:`, e);
            }
        }

        return () => {
            if (audioRef.current) {
                audioRef.current.srcObject = null;
            }
        };
    }, [stream, username]);

    return (
        <audio
            ref={audioRef}
            autoPlay
            playsInline
            muted={isLocal}
            id={`audio-${username}`}
            data-username={username}
            data-display-name={displayName}
        />
    );
};

export default PublisherAudioPlayer;
